export const getMessageType = (statusCode: number) => {
  switch (statusCode) {
    case 200:
    case 201:
      return "success"
    default:
      return "error"
  }
}
